var loginFormModule = function(){
	var scope = ".js-mod-login";
	ui.ready(
        scope,
		function($login){
		    var $loginForm = $login.find(scope+"__form");
            $loginForm.submit(
                function(ev){
					ev.preventDefault();
					var $button = $loginForm.find(scope+"__button");
                    var isOk = $loginForm.checkRestrictions();
                    if(isOk){
                        $button.prop("disabled",true);
                        gvf.endpoint(
                        	"web\\loginController::login",
                            [$loginForm.getValues()],
                            function(response){
                                $button.prop("disabled",false);
                                if(response.status=="ok"){
                                    window.location = response.url;
                                }else{
                                    utils.alertEndpointResponse(response);
                                }
                            }
                        );
                    }
                }
            );

			$login.find(scope+"__login-fb").click(
				function(ev){
					ev.preventDefault();
					alert("login Facebook");
				}

			);
			$login.find(scope+"__login-g").click(
				function(ev){
					ev.preventDefault();
					alert("login  Google");
				}

			);
            $login.find(scope+"__logout").click(
                function(ev){
                    ev.preventDefault();
                    gvf.endpoint(
                        "web\\loginController::logout",
                        [],
                        function(response){
                            if(response.status=="ok"){
                                window.location = response.url;
                            }
                        }
                    );
                }
            );

			$login.find(scope+"__forget-pwd").click(
				function(ev){
                    ev.preventDefault();
                    var endpointResponse = null;
                    Swal.fire({
                        title:$login.attr('data-remember-pass'),
						input:'text',
                        showLoaderOnConfirm: true,
						inputValue:$loginForm.find("[name=email]").val(),
						showCancelButton:true,
                        preConfirm: function(value) {
                            return new Promise(function(resolve,reject) {
                                gvf.endpoint(
                                    "web\\loginController::resetPasswordRequest",
                                    [value, $login.attr('data-messaje-email')],
                                    function(response){
                                    	if(response.status=="ok"){
                                            endpointResponse = response;
                                            resolve();
										}else{
                                            reject(response);
										}
                                    }
                                );
                            }).catch(
                            	function(error){
                                    Swal.showValidationMessage(error.messages.join(","));
								}
							);
                        }
                    }).then(
                    	function(response){
                    		if(response.isConfirmed && endpointResponse.status=="ok"){
                                Swal.fire(
                                    {
                                        icon: "success",
                                        title: endpointResponse.message,
                                        showLoaderOnConfirm: true
                                    }
                                );
							}else{
                                utils.alertEndpointResponse(endpointResponse);
							}
						}
					);
                }
			);

            if($login.data("resetpass")){
                $login.find(scope+"__forget-pwd").click();
            }

            $login.find(scope+"__anonymous-user").click(
                function(ev){
                    ev.preventDefault();
                    var realEmail = $login.find("[name=real_email]").closest(".js-form-field").formFieldVal();
                    gvf.endpoint(
                        "web\\loginController::anonymousLogin",
                        [realEmail],
                        function(response){
                            if(response.status=="ok"){
                                window.location = response.url;
                            }else{
                                utils.alertEndpointResponse(response);
                            }
                        }
                    );
                }
            );

            $login.find(scope+"__show-action-buttons").click(
                function(ev){
                    ev.preventDefault();
                    $login.data("login-context","")
                    showOrHideLoginButton();
                }
            );

            $login.find(scope+"__show-login-block").click(
                function(ev){
                    ev.preventDefault();
                    $login.data("login-context","login")
                    showOrHideLoginButton();
                }
            );

            $login.find(scope+"__show-anonymous-block").click(
                function(ev){
                    ev.preventDefault();
                    $login.data("login-context","anonymous")
                    showOrHideLoginButton();
                }
            );

            function showOrHideLoginButton(){
                $login.find(scope+"__login-title").toggleClass('web-mod-login__hidden',!!($login.data("login-context")));
                $login.find(scope+"__show-action-buttons").toggleClass('web-mod-login__hidden',!($login.data("login-context")));
                $login.find(scope+"__login-action-buttons").toggleClass('web-mod-login__hidden',!!($login.data("login-context")));
                var contexts = ["login","anonymous"];
                contexts.forEach(function(context){
                    $login.find(scope+"__"+context+"-block").toggleClass('web-mod-login__hidden',!($login.data("login-context")==context));
                });
            }
		}
	);
}();

